import React, { useEffect, useState } from "react";
import { Card, CardContent, Typography, Grid, Button, Box, List, ListItem } from "@mui/material";
import { ReactComponent as Blockchainicon } from "../../assets/blockchainicon.svg";
import QRCode from "react-qr-code";
import { ReactComponent as Joker } from "../../assets/dashboardIcons/JokerIcon.svg"
import { ReactComponent as CheckCircleIcon } from "../../assets/dashboardIcons/dotIcon.svg"
import { ReactComponent as BlockChainIcon } from "../../assets/dashboardIcons/blockchainIconProductuion.svg"
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import produzioniFormAPI from "../../services/produzioniFormApi";
import CheckCircle from '@mui/icons-material/CheckCircle';
import Cancel from '@mui/icons-material/Cancel';
// ✅ Simple right icon

const phases = [
    { name: "Pianificazione della vendemmia", key: "vendemmia" },
    { name: "Raccolta Uva", key: "raccoltauva" },
    { name: "Trasporto e conferimento", key: "transporto" },
    { name: "Pigiatura e diraspatura", key: "pigiatura" },
    { name: "Fermentazione e macerazione", key: "fermentazione" },
    { name: "Pressatura e svinatura", key: "svinatura" },
    { name: "Affinamento e invecchiamento", key: "affinamento" },
    { name: "Imbottigliamento e stoccaggio", key: "stoccaggio" },
    { name: "Certificazioni", key: "certificazioni" },
];

const BlockChain = () => {
    const navigate = useNavigate();
    const singleProduzioneID = useSelector((state) => state.produzioni.singleProduzioneId);
    const [flags, setFlags] = useState({});

    const payload = {
        company_id: localStorage.getItem("company_id"),
        prod_id: singleProduzioneID,
    };

    useEffect(() => {
        const fetchFlags = async () => {
            try {
                const response = await produzioniFormAPI.getFlagApi(payload);
                setFlags(response.data.data || {});
            } catch (error) {
                console.error("Error fetching flags:", error);
            }
        };
        fetchFlags();


    }, []);

    const getPhaseColor = (key) => {
        const items = flags[key];
        return Array.isArray(items) && items.length > 0 ? "success" : "error";
    };

    return (
        <Box className='scannerBlock'>
            <h3 className="sectiontitleSmall">Tracciabilità</h3>
            <Card sx={{ display: "flex", maxWidth: 800, width: "100%", boxShadow: 3, borderRadius: 2 }}>
                {/* Left Side */}
                <Box className='scannerBlock__scannerBox'>
                    <Box className='scanner'>
                        <QRCode style={{ opacity: "1" }} value="https://blockchain.example.com/trace" size={128} />
                    </Box>
                    <Button
                        className="kkk123 blockChainBtn"
                        type="button"
                        onClick={() => {
                            navigate("/produzione/produzioni");
                            toast.success("Production Created Successfully");
                        }}
                    >
                        <p className="text">
                            <Blockchainicon />
                            <span className="defaultText">Dati inviati in blockchain</span>
                            <span className="hoverText">Controlla invio</span>
                        </p>
                    </Button>
                </Box>

                {/* Middle Content */}
                <CardContent>
                    <List className="listGroup">
                        <ListItem><Typography variant="body2">Validato da vivon</Typography></ListItem>
                        <ListItem>
                            <Typography sx={{ color: "#4799D5 !important", textDecoration: "underline", fontWeight: "700 !important" }} variant="body2">
                                0xd8b39cc71726b4dd6199964f273cc7ef554a15fe173e6bc0381f42a20b41fc26
                            </Typography>
                        </ListItem>
                        <ListItem>
                            <Box sx={{ display: "flex" }}>
                                <Typography variant="body2">Registrato il -</Typography>
                                <Typography sx={{ color: "#0D3972 !important", fontWeight: "700 !important", marginLeft: "6px" }} variant="body2">28/11/2024 - 5:34</Typography>
                            </Box>
                        </ListItem>
                        <ListItem>
                            <Box sx={{ display: "flex" }}>
                                <Typography variant="body2">Blockchain -</Typography>
                                <Typography sx={{ color: "#4799D5 !important", marginLeft: "10px" }} variant="body2"><BlockChainIcon /></Typography>
                            </Box>
                        </ListItem>
                        <ListItem>
                            <Typography variant="body2">Fasi registrate</Typography>
                        </ListItem>
                    </List>

                    {/* Phase List Split into Two Columns */}
                    <Box className='pianificazioneList__Row'>
                        <List className="pianificazioneList">
                            {phases.slice(0, 4).map((phase, index) => (
                                <ListItem className="listItem" key={index}>
                                    <Typography variant="body2">{phase.name}</Typography>
                                    {getPhaseColor(phase.key) === 'success' ? (
                                        <CheckCircle style={{ color: 'green', marginLeft: 8 }} />
                                    ) : (
                                        <Cancel style={{ color: 'red', marginLeft: 8 }} />
                                    )}
                                </ListItem>
                            ))}
                        </List>
                        <List className="pianificazioneList">
                            {phases.slice(4, 8).map((phase, index) => (
                                <ListItem className="listItem" key={index + 4}>
                                    <Typography variant="body2">{phase.name}</Typography>
                                    {getPhaseColor(phase.key) === 'success' ? (
                                        <CheckCircle style={{ color: 'green', marginLeft: 8 }} />
                                    ) : (
                                        <Cancel style={{ color: 'red', marginLeft: 8 }} />
                                    )}
                                </ListItem>
                            ))}
                        </List>
                    </Box>

                    {/* Mascot */}
                    <Box className='jokarImage'>
                        <Joker />
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
};

export default BlockChain;
